import React from 'react';
import { Header, Table } from 'semantic-ui-react';

import { GastoDiario } from '../../Gastos/tipos';
import { escribirMonto, imprimirMotivoGastoDiario } from '../../utilidades';
import { ListaDeResponsables } from '../tipos';

interface TablaGastosProps {
    readonly gastos: ReadonlyArray<GastoDiario>;
    totalGastosDiarios: number;
    listaDeResponsables: ReadonlyArray<ListaDeResponsables>;
}

const TablaGastos: React.FunctionComponent<TablaGastosProps> = props => {
    const { gastos, totalGastosDiarios, listaDeResponsables } = props;
    return (
        <div>
            <Header as='h4'>Gastos diarios</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={4}>Responsable</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Motivo</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Observacion</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Monto</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {gastos.map((gasto, indice) => (
                        <Table.Row key={indice}>
                            <Table.Cell>
                                {retornarNombreResponsable(gasto.responsableGasto)}
                            </Table.Cell>
                            <Table.Cell>
                                {gasto.motivoGasto === 'otro'
                                    ? gasto.otroMotivoGasto!
                                    : imprimirMotivoGastoDiario(gasto.motivoGasto)}
                            </Table.Cell>
                            <Table.Cell>{gasto.observacionesGasto}</Table.Cell>
                            <Table.Cell>{escribirMonto(gasto.montoGasto)}</Table.Cell>
                        </Table.Row>
                    ))}
                    <Table.Row warning>
                        <Table.Cell>Total</Table.Cell>
                        <Table.Cell />
                        <Table.Cell />
                        <Table.Cell>{escribirMonto(totalGastosDiarios)}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );

    function retornarNombreResponsable(id: string) {
        return listaDeResponsables.filter(x => x.id === id).map(x => x.nombre);
    }
};

export default TablaGastos;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaGastosDiarios.tsx